import { forwardRef } from "react";
import { IMaskInput, IMaskInputProps } from "react-imask";

import {
  InputContainer,
  InputContainerProps,
} from "../InputContainer/inputContainer";

type InputMaskProps = InputContainerProps & IMaskInputProps<HTMLInputElement>;

export const InputMask = forwardRef<HTMLInputElement, InputMaskProps>(
  ({ label, ...rest }, ref) => {
    return (
      <InputContainer label={label}>
        <IMaskInput inputRef={ref} {...rest} />
      </InputContainer>
    );
  }
);
